import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCalendar, FiUsers, FiTrendingUp, FiShield, FiHeart, FiBriefcase } = FiIcons;

const ContentSection = () => {
  const dayOneContent = [
    {
      title: "Beyond MBTI",
      description: "เลิกแบ่งคนแค่ Introvert/Extrovert แต่แบ่งคนด้วย 10 ธาตุและ 10 Gods (เจาะลึกถึงสันดานดิบ)"
    },
    {
      title: "The Attraction Code",
      description: "ทำไมเราถึงดึงดูดคนประเภทเดิมๆ เข้ามาซ้ำซาก? และวิธีดึงดูดคนที่ \"ใช่\" เข้ามา"
    },
    {
      title: "Boss & Subordinate Hack",
      description: "คู่มือการ \"อยู่เป็น\" กับเจ้านาย และวิธี \"ซื้อใจ\" ลูกน้องแต่ละธาตุ"
    }
  ];

  const dayTwoContent = [
    {
      title: "Toxic Detection",
      description: "วิธีดู \"คนอันตราย\" ในรูปแบบต่างๆ (คนขี้โกง, คนเจ้าชู้, คนหน้าไหว้หลังหลอก)"
    },
    {
      title: "Conflict Resolution",
      description: "เมื่อทะเลาะกัน... คนธาตุไหนต้องงอ้ด้วยเหตุผล? คนธาตุไหนต้องงอ้ด้วยของขวัญ?"
    },
    {
      title: "Business Partner Matching",
      description: "สูตรลับจับคู่หุ้นส่วน เลือกยังไงให้ธุรกิจพุ่งไม่ใช่พัง"
    }
  ];

  return (
    <section className="py-20 px-4 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-blue-900/10 to-transparent"></div>
      
      <div className="relative z-10 max-w-6xl mx-auto">
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            เรียนอะไรบ้างใน <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">2 วัน</span>?
          </h2>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Day 1 */}
          <motion.div
            initial={{ x: -50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="bg-slate-800/50 backdrop-blur-sm border border-blue-500/30 rounded-2xl p-8">
              <div className="flex items-center mb-8">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-full flex items-center justify-center mr-4">
                  <SafeIcon icon={FiCalendar} className="text-xl text-white" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-white">Day 1</h3>
                  <p className="text-blue-400 font-medium">The Art of Connection (ศิลปะการอ่านคน)</p>
                </div>
              </div>

              <div className="space-y-6">
                {dayOneContent.map((item, index) => (
                  <motion.div
                    key={index}
                    initial={{ y: 20, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.6, delay: index * 0.1 }}
                    viewport={{ once: true }}
                    className="group"
                  >
                    <div className="bg-slate-700/30 border border-slate-600/50 rounded-xl p-4 hover:border-blue-500/50 transition-all duration-300">
                      <h4 className="text-lg font-semibold text-blue-300 mb-2">
                        ● {item.title}:
                      </h4>
                      <p className="text-gray-300 leading-relaxed">
                        {item.description}
                      </p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>

          {/* Day 2 */}
          <motion.div
            initial={{ x: 50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <div className="bg-slate-800/50 backdrop-blur-sm border border-purple-500/30 rounded-2xl p-8">
              <div className="flex items-center mb-8">
                <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center mr-4">
                  <SafeIcon icon={FiShield} className="text-xl text-white" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-white">Day 2</h3>
                  <p className="text-purple-400 font-medium">Crisis & Management (การจัดการความสัมพันธ์)</p>
                </div>
              </div>

              <div className="space-y-6">
                {dayTwoContent.map((item, index) => (
                  <motion.div
                    key={index}
                    initial={{ y: 20, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.6, delay: index * 0.1 + 0.2 }}
                    viewport={{ once: true }}
                    className="group"
                  >
                    <div className="bg-slate-700/30 border border-slate-600/50 rounded-xl p-4 hover:border-purple-500/50 transition-all duration-300">
                      <h4 className="text-lg font-semibold text-purple-300 mb-2">
                        ● {item.title}:
                      </h4>
                      <p className="text-gray-300 leading-relaxed">
                        {item.description}
                      </p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>

        {/* Course Details */}
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
          className="mt-16 text-center"
        >
          <div className="bg-gradient-to-r from-indigo-500/20 to-purple-500/20 backdrop-blur-sm border border-indigo-500/30 rounded-2xl p-8 max-w-4xl mx-auto">
            <div className="grid md:grid-cols-3 gap-6 mb-8">
              <div className="text-center">
                <SafeIcon icon={FiCalendar} className="text-3xl text-indigo-400 mx-auto mb-2" />
                <h4 className="font-semibold text-white">วันเรียน</h4>
                <p className="text-gray-300">21-22 ก.พ. 2569</p>
                <p className="text-gray-400 text-sm">(เสาร์-อาทิตย์)</p>
              </div>
              
              <div className="text-center">
                <SafeIcon icon={FiUsers} className="text-3xl text-purple-400 mx-auto mb-2" />
                <h4 className="font-semibold text-white">สถานที่</h4>
                <p className="text-gray-300">โรงแรมมาตรฐาน</p>
                <p className="text-gray-400 text-sm">กรุงเทพฯ</p>
              </div>
              
              <div className="text-center">
                <SafeIcon icon={FiTrendingUp} className="text-3xl text-pink-400 mx-auto mb-2" />
                <h4 className="font-semibold text-white">ที่นั่งจำกัด</h4>
                <p className="text-gray-300">20 ท่านแรก</p>
                <p className="text-gray-400 text-sm">เน้นสอนเจาะลึก</p>
              </div>
            </div>
            
            <button className="group relative px-8 py-4 bg-gradient-to-r from-indigo-500 to-purple-600 text-white font-bold text-lg rounded-full shadow-2xl hover:shadow-indigo-500/25 transition-all duration-300 transform hover:scale-105 border border-indigo-400/50">
              <span>จองที่นั่งทันที - เรียนรู้ศิลปะการอ่านคน</span>
              <div className="absolute inset-0 bg-gradient-to-r from-indigo-600 to-purple-700 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10"></div>
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ContentSection;